export const ORDER_STATUS = {
  abandoned: 'Abandonnée',
  paid: 'Payée',
  waiting: 'En attente de paiement',
  refuse: 'Refusée',
  canceled: 'Annulée',
  refund: 'Remboursée',
  partial: 'Partielle',
};
